<template>
  <div class="water-supply-num">
    <custom-plane>
      <div class="water-content">
        <div class="water-num">
          <div class="num-item">
            <div class="title">运行数量</div>
            <div class="sub-title normal-color">{{ normalData }}</div>
          </div>
          <div class="num-item margin-lr">
            <div class="title">待机数量</div>
            <div class="sub-title">{{ standbyData }}</div>
          </div>
          <div class="num-item">
            <div class="title">故障数量</div>
            <div class="sub-title error-color">{{ faultData }}</div>
          </div>
        </div>
        <div class="chart-content">
          <custom-charts :dataList="dataList"></custom-charts>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  props: {
    waterSupplyData: Object,
  },
  data() {
    return {
      dataList: {
        x: [],
        y: [],
      },
    };
  },
  watch: {
    waterSupplyData() {
      this.loadChartData();
    },
  },
  computed: {
    normalData() {
      return this.waterSupplyData?.count?.normal ?? "-";
    },
    standbyData() {
      return this.waterSupplyData?.count?.standby ?? "-";
    },
    faultData() {
      return this.waterSupplyData?.count?.fault ?? "-";
    },
  },
  methods: {
    loadChartData() {
      this.dataList = {
        x: [],
        y: [],
      };
      if (this.waterSupplyData?.historical?.length) {
        this.waterSupplyData.historical.map((item) => {
          let [res] = Object.entries(item);
          this.dataList.x.push(res[0].slice(10, 13));
          this.dataList.y.push(res[1]);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.water-supply-num {
  width: 100%;
  height: 409px;

  .water-content {
    padding-top: 40px;
    padding-left: 20px;
    .water-num {
      padding-left: 14px;
      display: flex;
      .margin-lr {
        margin: 0 42px;
      }
      .num-item {
        width: 88px;
        text-align: center;
        color: #ffffff;

        .title {
          font-weight: 500;
          font-size: 18px;
          line-height: 27px;
        }
        .sub-title {
          margin-top: 10px;
          font-family: "dina";
          font-weight: 500;
          font-size: 48px;
          line-height: 55px;
        }
      }
    }
    .chart-content {
      margin-top: 30px;
      width: 356px;
      height: 184px;
    }
  }
}
</style>
